var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_62488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_62488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19H8.5C7.95 19 7.47917 18.8042 7.0875 18.4125C6.69583 18.0208 6.5 17.55 6.5 17V3C6.5 2.45 6.69583 1.97917 7.0875 1.5875C7.47917 1.19583 7.95 1 8.5 1H15.5L21.5 7V17C21.5 17.55 21.3042 18.0208 20.9125 18.4125C20.5208 18.8042 20.05 19 19.5 19ZM14.5 8V3H8.5V17H19.5V8H14.5ZM4.5 23C3.95 23 3.47917 22.8042 3.0875 22.4125C2.69583 22.0208 2.5 21.55 2.5 21V7H4.5V21H15.5V23H4.5Z",
    fill: "#1A5C4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.9604f164dc0c7a6f21beaad27e304cd5.svg";
export { ForwardRef as ReactComponent };